export default __webpack_public_path__ + "i18n/translations/translation-tr.1bd49238.json";